import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

function sizeFormatter(params) {
  let size = params.value;
  if (size === null)  { return '-'; }
  const power = 1024;
  let n = 0;
  let powerN = {0 : 'B', 1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'};
  while (size > power) {
    size /=  power;
    n += 1;
  }
  size = Math.round(size * 10) / 10;

  return size.toString() + ' ' + powerN[n];
}

function dateFormatter(params) {
  let timestamp = params.value;
  if (timestamp === null) { return '-'; }

  let date = dayjs(timestamp);
  let formattedTime = `${date.fromNow(true)} ago`;
  return formattedTime;
}

function typeFormatter(params) {
  let ext = params.value;
  if (ext == '/dir') { return 'Directory'; }
  else { return params.value; }
}

export { sizeFormatter, dateFormatter, typeFormatter }